module.exports = __webpack_public_path__ + "img/user.3720062b.png";